import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import foodimg1 from "../../images/food1.jpg"; // Import the first image
import foodimg2 from "../../images/food2.jpg"; // Import the second image

function CuisinTwo() {
    return (
        <Box
            sx={{
                textAlign: "center",
                padding: "40px 20px",
                maxWidth: "1200px",
                margin: "0 auto",
                color: "#333",
            }}
        >
            {/* Icon */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "16px",
                    fontSize: "48px",
                    color: "#C2A574", // Gold color for the icon
                }}
            >
                <i className="flaticon-breakfast-3"></i>
            </Box>

            {/* Subtitle */}
            <Typography
                variant="overline"
                sx={{
                    fontSize: "14px",
                    textTransform: "uppercase",
                    letterSpacing: "1.5px",
                    color: "#777",
                    fontWeight: "bold",
                }}
            >
                Perfect Fine Dine Experiences
            </Typography>

            {/* Title */}
            <Typography
                variant="h3"
                sx={{
                    fontSize: "36px",
                    fontWeight: "bold",
                    margin: "16px 0",
                    fontFamily: "Georgia, serif",
                }}
            >
                Culinary At Knuckles
            </Typography>

            {/* Description */}
            <Typography
                variant="body1"
                sx={{
                    fontSize: "16px",
                    lineHeight: 1.8,
                    marginBottom: "32px",
                }}
            >
                At Unseen Knuckles, the local cuisine offers a gateway to the region’s
                rich culinary traditions. Our talented chef is passionate about
                preserving authentic recipes while showcasing fresh, locally sourced
                ingredients. Whether you’re in the mood for a hearty meal or a light
                snack, our menu caters to every palate. Every meal becomes a
                celebration of the region’s gastronomic heritage.
            </Typography>

            {/* Images Section */}
            <Grid container spacing={4}>
                {/* Image 1 */}
                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            position: "relative",
                            backgroundImage: `url(${foodimg2})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            height: "300px",
                            //   borderRadius: "8px",
                            overflow: "hidden",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            // border: "2px solid white",

                        }}
                    >

                        <Box
                            sx={{
                                position: "relative",
                                backgroundImage: `url(${foodimg2})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                height: "300px",
                                overflow: "hidden",
                            }}
                        >
                            {/* Inner Box for Border */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "10px", // Adjust as needed to move the border inside
                                    left: "10px",
                                    right: "10px",
                                    bottom: "10px",
                                    border: "2px solid white", // Define the border here
                                    pointerEvents: "none", // Ensures the border doesn't interfere with user interaction
                                }}
                            />
                        </Box>

                        {/* Overlay */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 1,
                            }}
                        />
                        {/* Content */}
                        <Box
                            sx={{
                                position: "relative",
                                zIndex: 2,
                                color: "#fff",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                padding: "16px",
                            }}
                        >



                        </Box>
                    </Box>
                </Grid>

                {/* Image 2 */}
                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            position: "relative",
                            backgroundImage: `url(${foodimg1})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            height: "300px",
                            //   borderRadius: "8px",
                            overflow: "hidden",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        }}
                    >

<Box
                            sx={{
                                position: "relative",
                                backgroundImage: `url(${foodimg1})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                height: "300px",
                                overflow: "hidden",
                            }}
                        >
                            {/* Inner Box for Border */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "10px", // Adjust as needed to move the border inside
                                    left: "10px",
                                    right: "10px",
                                    bottom: "10px",
                                    border: "2px solid white", // Define the border here
                                    pointerEvents: "none", // Ensures the border doesn't interfere with user interaction
                                }}
                            />
                        </Box>
                        {/* Overlay */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: 1,
                            }}
                        />
                        {/* Content */}
                        <Box
                            sx={{
                                position: "relative",
                                zIndex: 2,
                                color: "#fff",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                padding: "16px",
                            }}
                        >

                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default CuisinTwo;
